import React, { useState } from 'react';
import './PasswordChange.css';
import Title from './Title';
import { useTranslation } from 'react-i18next';
import { changePassword } from "../../network/api/user.js"; // Import the function to change password

const PasswordChange = ({ getUserName }) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [error, setError] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    const specialCharacters = /[!@#$%^&*(),.?":{}|<>]/;

    if (newPassword.length < 6) {
      setError("Password must be at least 6 characters long.");
      return;
    }

    if (newPassword !== confirmNewPassword) {
      setError("Passwords don't match.");
      return;
    }

    if (!newPassword.match(/[A-Z]/)) {
      setError("Password must contain at least one uppercase letter.");
      return;
    }

    if (!newPassword.match(/[a-z]/)) {
      setError("Password must contain at least one lowercase letter.");
      return;
    }

    if (!newPassword.match(/[0-9]/)) {
      setError("Password must contain at least one number.");
      return;
    }

    if (!specialCharacters.test(newPassword)) {
      setError(
        'Password must contain at least one special character: !@#$%^&*(),.?":{}|<>'
      );
      return;
    }

    setError("");
    console.log({ password: newPassword, cPassword: confirmNewPassword })
    changePassword({ password: newPassword, cPassword: confirmNewPassword })
      .then((response) => {
        setError("Password changed successfully!");
        // Clear the form fields after successful password change
        setOldPassword("");
        setNewPassword("");
        setConfirmNewPassword("");
      })
      .catch((err) => {
        setError(err.message || "An error occurred while changing the password.");
        console.log(err);
      });
  };

  return (
    <div className="d-flex flex-column w-100">
      <Title title={getUserName} text="أهلا بك فى حسابك" />
      <div className='account-item p-3 flex-grow-1'>
        <div className="d-flex justify-content-between">
          <div className='head d-flex gap-1 align-items-center'>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.9974 9.33317C9.83834 9.33317 11.3307 7.84079 11.3307 5.99984C11.3307 4.15889 9.83834 2.6665 7.9974 2.6665C6.15645 2.6665 4.66406 4.15889 4.66406 5.99984C4.66406 7.84079 6.15645 9.33317 7.9974 9.33317ZM7.9974 9.33317C5.05188 9.33317 2.66406 11.124 2.66406 13.3332M7.9974 9.33317C10.9429 9.33317 13.3307 11.124 13.3307 13.3332" stroke="#C99700" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <h2>{t('Account')}</h2>
          </div>
        </div>
        <div className="user-account flex-grow-1">
          <ul className="me-4 mb-0">
            <li className="fw-bold">تغير كلمة المرور</li>
          </ul>
          {error && (
            <div className={`alert ${error === "Password changed successfully!" ? "alert-success" : "alert-danger"}`} role="alert">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <label htmlFor="newPassword">كلمه المرور الجديده</label>
            <div className="inp">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder='ادخل كلمه المرور الجديده'
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <div onClick={() => setShowPassword(!showPassword)}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.95245 4.2436C9.29113 4.19353 9.64051 4.16667 10.0003 4.16667C14.2545 4.16667 17.0461 7.9207 17.9839 9.40569C18.0974 9.58542 18.1542 9.67528 18.1859 9.81389C18.2098 9.91799 18.2098 10.0822 18.1859 10.1863C18.1541 10.3249 18.097 10.4154 17.9827 10.5963C17.7328 10.9918 17.3518 11.5476 16.8471 12.1504M5.6036 5.59586C3.80187 6.81808 2.57871 8.51615 2.01759 9.4044C1.90357 9.58489 1.84656 9.67514 1.81478 9.81373C1.79091 9.91783 1.7909 10.082 1.81476 10.1861C1.84652 10.3247 1.90328 10.4146 2.01678 10.5943C2.95462 12.0793 5.74618 15.8333 10.0003 15.8333C11.7157 15.8333 13.1932 15.223 14.4074 14.3972M2.50035 2.5L17.5003 17.5M8.23258 8.23223C7.78017 8.68464 7.50035 9.30964 7.50035 10C7.50035 11.3807 8.61964 12.5 10.0003 12.5C10.6907 12.5 11.3157 12.2202 11.7681 11.7678" stroke="#B0B0B0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
            <label htmlFor="confirmNewPassword">كلمه المرور الجديده مره اخري</label>
            <div className="inp">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder='ادخل كلمه المرور الجديده مره اخري'
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                required
              />
              <div onClick={() => setShowPassword(!showPassword)}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.95245 4.2436C9.29113 4.19353 9.64051 4.16667 10.0003 4.16667C14.2545 4.16667 17.0461 7.9207 17.9839 9.40569C18.0974 9.58542 18.1542 9.67528 18.1859 9.81389C18.2098 9.91799 18.2098 10.0822 18.1859 10.1863C18.1541 10.3249 18.097 10.4154 17.9827 10.5963C17.7328 10.9918 17.3518 11.5476 16.8471 12.1504M5.6036 5.59586C3.80187 6.81808 2.57871 8.51615 2.01759 9.4044C1.90357 9.58489 1.84656 9.67514 1.81478 9.81373C1.79091 9.91783 1.7909 10.082 1.81476 10.1861C1.84652 10.3247 1.90328 10.4146 2.01678 10.5943C2.95462 12.0793 5.74618 15.8333 10.0003 15.8333C11.7157 15.8333 13.1932 15.223 14.4074 14.3972M2.50035 2.5L17.5003 17.5M8.23258 8.23223C7.78017 8.68464 7.50035 9.30964 7.50035 10C7.50035 11.3807 8.61964 12.5 10.0003 12.5C10.6907 12.5 11.3157 12.2202 11.7681 11.7678" stroke="#B0B0B0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
            <div className="d-flex justify-content-start align-items-center">
              <button type="submit" className='change-pass w-25'>تغيير كلمة المرور</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default PasswordChange;